import React from 'react';
import PropTypes from 'prop-types';

import { useDirection } from '../../hooks';
import Container from './Container';
import Decoration from './Decoration';
import DecorationDot from './DecorationDot';
import IconContainer from './IconContainer';
import Line from './Line';

const DecorationLine = ({
  decorationType,
  lineType,
  theme = 'default',
  iconBackground = true,
  alignTop = false,
  lineGrey = false,
  lineBottom,
  width,
  decorationSize = 'small',
}) => {
  const isRtl = useDirection();
  const isIcon = React.isValidElement(decorationType);

  return (
    <Container
      iconBackground={iconBackground}
      alignTop={alignTop}
      circleDotTop={decorationType === 'circleDot'}
      width={width}
    >
      <Line
        type={lineType}
        color={theme}
        iconBackground={iconBackground}
        alignTop={alignTop}
        lineGrey={lineGrey}
        lineBottom={lineBottom}
      />
      {isIcon ? (
        <IconContainer
          iconBackground={iconBackground}
          color={theme}
          decorationSize={decorationSize}
        >
          {React.cloneElement(decorationType)}
        </IconContainer>
      ) : (
        <Decoration
          type={decorationType}
          color={theme}
          reverse={isRtl}
          decorationSize={decorationSize}
        >
          {decorationType === 'circleDot' && (
            <DecorationDot color={theme} decorationSize={decorationSize} />
          )}
        </Decoration>
      )}
    </Container>
  );
};

DecorationLine.propTypes = {
  lineType: PropTypes.string.isRequired,
  decorationType: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  theme: PropTypes.oneOf([
    'default',
    'negative',
    'dark',
    'grey',
    'train',
    'flight',
    'primary',
  ]),
  iconBackground: PropTypes.bool,
  alignTop: PropTypes.bool,
  lineGrey: PropTypes.bool,
  lineBottom: PropTypes.string,
  decorationSize: PropTypes.oneOf(['small', 'base', 'big']),
};

export default DecorationLine;
